import React from 'react';
import ClassAssembly12B2026 from 'views/ClassAssembly12B2026';

const ClassAssemblyPage = () => {
  return <ClassAssembly12B2026 />;
};

export default ClassAssemblyPage;
